import { RestaurantAnimationDto } from '@timechef/core/api';
import { ensureDate } from '@timechef/core/utils';
import { AnimationsByPeriod, AnimationsPeriodEnum } from './animations.models';

// Do not store this grouping because it changes every day, instead we compute it on the fly when required
export const computeAnimations = (today: Date, dtos: RestaurantAnimationDto[], existing?: AnimationsByPeriod[]): AnimationsByPeriod[] => {
  const animationsByPeriod: AnimationsByPeriod[] = existing || [
    { period: AnimationsPeriodEnum.Today, items: [] },
    { period: AnimationsPeriodEnum.Incoming, items: [] },
  ];

  dtos.forEach((animation) => {
    const date = ensureDate(animation.startsAt);
    if (date <= today) getAnimationsByPeriod(animationsByPeriod, AnimationsPeriodEnum.Today)!.push(animation);
    else getAnimationsByPeriod(animationsByPeriod, AnimationsPeriodEnum.Incoming)!.push(animation);
  });

  return animationsByPeriod;
};

export const getAnimationsByPeriod = (animations: AnimationsByPeriod[], period: AnimationsPeriodEnum) => animations.find((x) => x.period === period)?.items;
